module.exports = __webpack_public_path__ + "img/aguaaculco.dec41cab.jpg";